function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.667 10a8.333 8.333 0 1016.666 0 8.333 8.333 0 00-16.666 0zm15.151 0a6.818 6.818 0 11-13.636 0 6.818 6.818 0 0113.636 0zm-7.576.758v3.03h1.516v-3.03h3.03V9.242h-3.03v-3.03H9.242v3.03h-3.03v1.516h3.03z",
  fill: "#669AEC"
});

var SvgPlusCircle = function SvgPlusCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20"
  }), _ref);
};

export default SvgPlusCircle;